<template>
  <div>
    <div class="top-bg">
      <!--头部开始 -->
      <top-part></top-part>
      <!-- 头部结束 -->
      <!-- 头部导航开始 -->
      <div class="top-nav">
        <van-tabs
          v-model="activeName"
          background="#29BEBC"
          color="#fff"
          line-height="2px"
          line-width="28px"
          @change="changeTab"
          :border="false"
        >
          <van-tab
            title-style="color: #fff"
            v-for="(item,index) of tabList"
            :key="index"
            :title="item.title"
            :name="item.name"
          >
            <div class="sports-date">{{timeDay}}</div>
            <!-- 平均步数与总步数开始 -->
            <div class="average-box">
              <div class="average-item1">
                <p class="text-week">{{dateString}}</p>
              </div>
              <div class="average-item" v-show="changeTabName.day">
                <p class="average-p1">平均步数</p>
                <p class="average-p2">{{avgSteps}}</p>
              </div>
              <div class="average-item">
                <p class="average-p1">总步数</p>
                <p class="average-p2">{{todaySteps}}</p>
              </div>
            </div>
            <!-- 平均步数与总步数结束 -->
            <!-- 柱状图开始 -->
            <div style="margin-top: -20px;" v-show="changeTabName.all">
              <Histogram :echartsDate="echartsDate" :tabName="activeName"></Histogram>
            </div>
            <!-- 柱状图结束 -->
          </van-tab>
        </van-tabs>
      </div>
      <!-- 头部导航结束 -->

      <div class="content-box">
        <div v-if="noDate">
          <van-empty
            class="custom-image"
            :image="require('../../assets/images/null@2x.png')"
            description="暂无数据"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import moment from "moment";
import topPart from "../../components/topPart";
import Histogram from "./components/Histogram";
export default {
  components: {
    topPart,
    Histogram
  },
  data() {
    return {
      activeName: "day",
      tabList: [
        { title: "日", name: "day" },
        { title: "周", name: "week" },
        { title: "月", name: "month" },
        { title: "总", name: "all" }
      ],
      list: [],
      noDate: false,
      dateString: "日", //代表日周月总文案
      todaySteps: localStorage.getItem("stepAll"), // 总步数
      timeDay: moment(this.centralControl.utils.obtainEast8Date()).format(
        "MM月DD日"
      ),
      echartsDate: {},
      avgSteps: 0 //平均步数
    };
  },
  computed: {
    //当tab为日的时候，平均步数不显示,当tab为总的时候，柱状图不显示
    changeTabName: function() {
      return {
        day: this.activeName !== "day" ? true : false, //tab为日
        all: this.activeName !== "all" ? true : false //tab为总
      };
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 改变tab
    changeTab(name, title) {
      this.dateString = title;
      this.echartsDate = {}; //重置柱状图数据
      this.activeName = name;
      this.getStep();
    },
    // 获取个人日周月步数柱状图数据
    getStep() {
      this.centralControl.axios.centralControl(
        "getStaffStepStatistic",
        res => {
          if (res.code == 200) {
            this.echartsDate = res.data;
            var data = JSON.parse(JSON.stringify(this.echartsDate)); //操作克隆对象--swq
            this.replayVal(data);
          } else {
            this.$message.error(res.message);
          }
        },
        {
          type: this.activeName
        }
      );
    },
    // tab为日
    day(dataDetail) {
      this.timeDay = moment(dataDetail).format("M月DD日");
    },
    // tab为周
    week(dataDetail) {
      let weekDate = dataDetail.split("_");
      let weekParts1 = moment(weekDate[0]).format("M月DD日");
      let weekParts2 = moment(weekDate[1]).format("M月DD日");
      this.timeDay = `${weekParts1} - ${weekParts2}`;
    },
    // tab为月
    month(dataDetail) {
      this.timeDay = moment(dataDetail).format("M月");
    },
    // tab为总
    all(dataDetail, data) {
      this.timeDay = "";
      this.todaySteps = data.stepCnt;
      this.avgSteps = data.avgCnt;
    },
    // 给日期,总步数，平均步数赋值
    replayVal(data) {
      var dataDetail = ""; //日期显示
      var alSteps = ""; //总步数
      var avgSteps = ""; //总步数
      if (data.timeList) {
        dataDetail = data.timeList[data.timeList.length - 1];
      }
      if (data.stepCounts) {
        alSteps = data.stepCounts[data.stepCounts.length - 1];
        this.todaySteps = alSteps;
      }
      if (data.avgCounts) {
        avgSteps = data.avgCounts[data.avgCounts.length - 1];
        this.avgSteps = avgSteps;
      }
      this[this.activeName](dataDetail, data);
    },
    init() {
      this.getStep();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/common.styl';

.top-bg {
  >>>.van-tabs__content {
    overflow: scroll;
  }
}

.top-nav {
  position: absolute;
  top: 44px;
  bottom: 0;
  overflow: scroll;
}

.top-box {
  color: #fff;
  background: #29bebc;
  box-shadow: none;
}

.return-text {
  color: #fff;
}

.top-nav {
  position: fixed;
  top: 38px;
  width: 100%;
  z-index: 999;
  bottom: 0;
  background: #fff;
}

.sports-date {
  height: 35px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 35px;
  background: #29BEBC;
  text-align: center;
  padding-bottom: 30px;
}

.average-box {
  display: flex;
  justify-content: center;
  align-content: center;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 6px 0px rgba(212, 218, 235, 0.5);
  border-radius: 8px;
  margin: 10px;
  padding: 10px 10px;
  position: relative;
  top: -40px;
}

.average-item {
  flex: 1;
  text-align: center;
  margin: 10px;
}

.average-item1 {
  width: 70px;
  text-align: center;
  margin: auto;
}

.average-p1 {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  line-height: 17px;
}

.average-p2 {
  height: 36px;
  font-size: 30px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
  line-height: 36px;
}

.text-week {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(86, 137, 240, 1);
  line-height: 28px;
  background: #F3F5FF;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: auto;
}
</style>